import { DOMAIN_CLINKS } from "constants/app";
export const filterField = (domain, allExpand = 1) => [
  {
    title: "Fields of work",
    name: "pathway",
    active: allExpand ? 0 : 1,
    isShow: domain === DOMAIN_CLINKS ? true : false,
  },
  {
    title: "People we work with",
    name: "target_group",
    active: allExpand ? 0 : 1,
    isShow: true,
  },
  // {
  //   title: "County / Area",
  //   name: "county",
  //   active: allExpand ? 0 : 1,
  //   isShow: domain === DOMAIN_CLINKS ? true : false,
  // },
  {
    title: "Probation Regions",
    name: "probation_regions",
    active: allExpand ? 0 : 1,
    isShow: true,
  },
  {
    title: "HMPPS Area",
    name: "regions",
    active: allExpand ? 0 : 1,
    isShow: true,
  },
  {
    title: "Area Covered",
    name: "area_covered",
    active: allExpand ? 0 : 1,
    isShow: true,
  },
  {
    title: "Prisons",
    name: "prisons",
    active: allExpand ? 0 : 1,
    isShow: true,
  },
  {
    title: "Custody or Community",
    name: "custody_or_community",
    active: allExpand ? 0 : 1,
    isShow: true,
  },
  // {
  //   title: "Racial Equity Specialist",
  //   name: "racially_minoritised",
  //   active: allExpand ? 0 : 1,
  //   isShow: true,
  // },
  {
    title: "Specialist Organisation",
    name: "specialist_organisation",
    active: allExpand ? 0 : 1,
    isShow: true,
  },
  {
    title: "Type of Organisation",
    name: "type_of_organisation",
    active: allExpand ? 0 : 1,
    isShow: true,
  },
];
